import { render, staticRenderFns } from "./applicant-login.vue?vue&type=template&id=2c50f8d0&scoped=true"
import script from "./applicant-login.vue?vue&type=script&lang=js"
export * from "./applicant-login.vue?vue&type=script&lang=js"
import style0 from "./applicant-login.vue?vue&type=style&index=0&id=2c50f8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c50f8d0",
  null
  
)

export default component.exports